module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/woman_holding_phone-4647b621d87d86597164eaf99c94e8f9.webp";